import {
  dataset,
  legendItemStyle
} from './echartStyleComm'
export function firstchart1EchartOp ({
  v
}) {
  let option = {
    color: [{
      type: 'linear',
      x: 1,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [{
        offset: 0,
        color: 'rgba(42, 187, 255, 1)' // 0% 处的颜色
      }, {
        offset: 1,
        color: 'rgba(2, 94, 226, 1)' // 100% 处的颜色
      }]
    },
    {
      type: 'linear',
      x: 1,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [{
        offset: 0,
        color: 'rgba(255, 138, 190, 1)' // 0% 处的颜色
      }, {
        offset: 1,
        color: 'rgba(243, 37, 122, 1)' // 100% 处的颜色
      }]
    },
    'rgba(73, 254, 255, 1)'
    ],
    grid: {
      left: '0%',
      top: '15%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    dataset: dataset,
    legend: {
      icon: 'rect',
      ...legendItemStyle({
        v
      })
    },
    xAxis: {
      name: '月',
      type: 'category'
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)',
        formatter: function (d, c, a) {
          return v.numberSplitWithComma(d / 10000)
        }
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.1)'
        }
      },
      nameTextStyle: {
        color: 'rgba(255, 255, 255,1)'
      }
    },
    series: [{
      type: 'bar',
      barWidth: 5
    },
    {
      type: 'bar',
      barWidth: 5
    },
    {
      type: 'line'
    }
    ]
  }
  return option
}

export function firstchart2EchartOp ({
  v
}) {
  let option = {
    color: [{
      type: 'linear',
      x: 1,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [{
        offset: 0,
        color: 'rgba(42, 187, 255, 1)' // 0% 处的颜色
      }, {
        offset: 1,
        color: 'rgba(2, 94, 226, 1)' // 100% 处的颜色
      }]
    },
    {
      type: 'linear',
      x: 1,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [{
        offset: 0,
        color: 'rgba(255, 138, 190, 1)' // 0% 处的颜色
      }, {
        offset: 1,
        color: 'rgba(243, 37, 122, 1)' // 100% 处的颜色
      }]
    },
    'rgba(73, 254, 255, 1)'
    ],
    grid: {
      left: '0%',
      top: '25%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    dataset: dataset,
    legend: {
      icon: 'rect',
      top: '10%',
      right: '0',
      ...legendItemStyle({
        v
      })
    },
    xAxis: {
      name: '月',
      type: 'category'
    },
    yAxis: {
      show: false,
      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)',
        formatter: function (d, c, a) {
          return v.numberSplitWithComma(d / 10000)
        }
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: {

      },
      nameTextStyle: {
        color: 'rgba(255, 255, 255,1)'
      }
    },
    series: [{
      type: 'bar',
      barWidth: 15
    },
    {
      type: 'bar',
      barWidth: 15
    }
    ]
  }

  return option
}

export function firstchart3EchartOp ({
  v
}) {
  let option = {
    color: [{
      type: 'linear',
      x: 1,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [{
        offset: 0,
        color: 'rgba(42, 187, 255, 1)' // 0% 处的颜色
      }, {
        offset: 1,
        color: 'rgba(2, 94, 226, 1)' // 100% 处的颜色
      }]
    },
    {
      type: 'linear',
      x: 1,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [{
        offset: 0,
        color: 'rgba(255, 138, 190, 1)' // 0% 处的颜色
      }, {
        offset: 1,
        color: 'rgba(243, 37, 122, 1)' // 100% 处的颜色
      }]
    },
    'rgba(73, 254, 255, 1)'
    ],
    grid: {
      left: '0%',
      top: '25%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    dataset: dataset,
    series: [{
      type: 'pie',
      radius: ['60%', '80%'],
      avoidLabelOverlap: false,
      itemStyle: {
        borderRadius: 4,
        borderColor: '#1c1839',
        borderWidth: 2
      },
      label: {
        show: false,
        position: 'center'
      },
      emphasis: {
        label: {
          show: true,
          formatter: function (value) {
            return '1111'
          }
        }
      }
    }]
  }

  return option
}

export function firstchart4EchartOp ({ v }) {
  let option = {
    color: [{
      type: 'linear',
      x: 1,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [{
        offset: 0,
        color: 'rgba(42, 187, 255, 1)' // 0% 处的颜色
      }, {
        offset: 1,
        color: 'rgba(2, 94, 226, 1)' // 100% 处的颜色
      }]
    },
    {
      type: 'linear',
      x: 1,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [{
        offset: 0,
        color: 'rgba(255, 138, 190, 1)' // 0% 处的颜色
      }, {
        offset: 1,
        color: 'rgba(243, 37, 122, 1)' // 100% 处的颜色
      }]
    },
    'rgba(73, 254, 255, 1)'
    ],
    grid: {
      left: '0%',
      top: '15%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    dataset: dataset,
    legend: {
      icon: 'rect',
      ...legendItemStyle({
        v
      })
    },
    xAxis: {
      name: '月',
      type: 'category'
    },
    yAxis: {

      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)',
        formatter: function (d, c, a) {
          return v.numberSplitWithComma(d / 10000)
        }
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.1)'
        }
      },
      nameTextStyle: {
        color: 'rgba(255, 255, 255,1)'
      }
    },
    series: [{
      type: 'line',
      barWidth: 5
    },
    {
      type: 'line',
      barWidth: 5
    },
    {
      type: 'line'
    }
    ]
  }
  return option
}
export function firstchart5EchartOp ({ v }) {
  let option = {
    color: [{
      type: 'linear',
      x: 1,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [{
        offset: 0,
        color: 'rgba(42, 187, 255, 1)' // 0% 处的颜色
      }, {
        offset: 1,
        color: 'rgba(2, 94, 226, 1)' // 100% 处的颜色
      }]
    },
    {
      type: 'linear',
      x: 1,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [{
        offset: 0,
        color: 'rgba(255, 138, 190, 1)' // 0% 处的颜色
      }, {
        offset: 1,
        color: 'rgba(243, 37, 122, 1)' // 100% 处的颜色
      }]
    },
    'rgba(73, 254, 255, 1)'
    ],
    grid: {
      left: '0%',
      top: '15%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    dataset: dataset,
    legend: {
      icon: 'rect',
      ...legendItemStyle({
        v
      })
    },
    xAxis: {
      name: '月',
      type: 'category'
    },
    yAxis: {

      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)',
        formatter: function (d, c, a) {
          return v.numberSplitWithComma(d / 10000)
        }
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.1)'
        }
      },
      nameTextStyle: {
        color: 'rgba(255, 255, 255,1)'
      }
    },
    series: [{
      type: 'bar',
      barWidth: 5
    },
    {
      type: 'bar',
      barWidth: 5
    },
    {
      type: 'line'
    }
    ]
  }
  return option
}
